import { useEffect, useState } from "react";
import { Customer } from "@/api/customers";
import { CustomerUserModel, CustomerUser } from "@/api/users";
import RigthPanel, { RigthPanelType } from "@/ui-controls/RigthPanel";
import NewCustomerUserForm from "@/components/customers/customer_users/NewCustomerUserForm";
interface Props {
  customer: Customer | undefined;
  isPanelOpenned: boolean;
  isEditMode?: boolean;
  onPanelClosed?: () => any;
  onSave?: (customerUser: CustomerUserModel) => any;
  onUpdated?: () => any;
  selectedUser?: CustomerUser | null;
  onShowSuccess?: (message: string) => any;
  onShowWarnings?: (messages: string[]) => any;
}

const NewCustomerUserPanel = (props: Props) => {
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    setIPanelOpen(props.isPanelOpenned);
  }, [props.isPanelOpenned]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onPanelClosed) props.onPanelClosed();
  };

  return (
    <>
      <RigthPanel
        header={
          props.isEditMode
            ? `Edit user for customer '${props.customer?.Name}'`
            : `New user for customer '${props.customer?.Name}'`
        }
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={NewCustomerUserForm}
        type={RigthPanelType.medium}
        childProps={{
          customer: props.customer,
          isEditMode: props.isEditMode,
          selectedUser: props.selectedUser,
          onClose: () => onClosePanel(),
          onSave: (customerUserModel: CustomerUserModel) => {
            if (props.onSave) {
              props.onSave(customerUserModel);
            }
            onClosePanel();
          },
          onUpdated: props.onUpdated,
          onShowSuccess: props.onShowSuccess,
          onShowWarnings: props.onShowWarnings,
        }}
      ></RigthPanel>
    </>
  );
};

export default NewCustomerUserPanel;
